// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TransactionList-module_transaction_table_mPQ_s {
  width: 100%;
  margin-top: 8px;
}

.TransactionList-module_transaction_table_mPQ_s td {
  padding: 6px 2px;
}

.TransactionList-module_total_label_cell_H2asg {
  font-weight: 700;
  text-align: right;
}

.TransactionList-module_table_header_cell_qVo3J {
  text-align: unset;
  white-space: nowrap;
}

.TransactionList-module_money_cell__exLN {
}

.TransactionList-module_cleared_cell_qj_jo {
  text-align: center;
  color: var(--status_received);
}

.TransactionList-module_not_cleared_cell_gx5Nz {
  text-align: center;
  color: var(--status_approved);
}

.TransactionList-module_light_border_bottom_sfMOv {
  border-bottom: 1px solid var(--bp-light-gray1);
}

.TransactionList-module_light_background_RI7Ew {
  background-color: var(--bp-light-gray5);
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Transactions/TransactionList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".transaction_table {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.transaction_table td {\n  padding: 6px 2px;\n}\n\n.total_label_cell {\n  font-weight: 700;\n  text-align: right;\n}\n\n.table_header_cell {\n  composes: table_header_cell from 'Styles/styles.module.css';\n  text-align: unset;\n  white-space: nowrap;\n}\n\n.money_cell {\n  composes: money_cell from 'Styles/styles.module.css';\n}\n\n.cleared_cell {\n  text-align: center;\n  color: var(--status_received);\n}\n\n.not_cleared_cell {\n  text-align: center;\n  color: var(--status_approved);\n}\n\n.light_border_bottom {\n  border-bottom: 1px solid var(--bp-light-gray1);\n}\n\n.light_background {\n  background-color: var(--bp-light-gray5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transaction_table": `TransactionList-module_transaction_table_mPQ_s`,
	"total_label_cell": `TransactionList-module_total_label_cell_H2asg`,
	"table_header_cell": `TransactionList-module_table_header_cell_qVo3J ${___CSS_LOADER_ICSS_IMPORT_0___.locals["table_header_cell"]}`,
	"money_cell": `TransactionList-module_money_cell__exLN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["money_cell"]}`,
	"cleared_cell": `TransactionList-module_cleared_cell_qj_jo`,
	"not_cleared_cell": `TransactionList-module_not_cleared_cell_gx5Nz`,
	"light_border_bottom": `TransactionList-module_light_border_bottom_sfMOv`,
	"light_background": `TransactionList-module_light_background_RI7Ew`
};
export default ___CSS_LOADER_EXPORT___;
